import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { runClientStorageMigration } from "@/lib/clientStorage";
import { installResizeObserverGuard } from "@/lib/resizeObserver";

runClientStorageMigration();
installResizeObserverGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
